module.exports = __webpack_public_path__ + "img/vignettes-asso_0008_nature-et-aventure.0ac5bf32.jpg";